import * as React from "react"

export const Close = ({ ...props }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18.1215 16L24.061 10.0605C24.332 9.7895 24.5 9.414 24.5 9C24.5 8.1715 23.8285 7.5 23 7.5C22.586 7.5 22.211 7.668 21.9395 7.9395L16 13.8785L10.0605 7.9395C9.789 7.668 9.414 7.5 9 7.5C8.1715 7.5 7.5 8.1715 7.5 9C7.5 9.414 7.668 9.789 7.9395 10.0605L13.8785 16L7.9395 21.9395C7.668 22.211 7.5 22.586 7.5 23C7.5 23.8285 8.1715 24.5 9 24.5C9.414 24.5 9.789 24.332 10.0605 24.0605L16 18.1215L21.9395 24.061C22.211 24.332 22.586 24.5 23 24.5C23.8285 24.5 24.5 23.8285 24.5 23C24.5 22.586 24.332 22.211 24.0605 21.9395L18.1215 16Z"
      fill="#111111"
    ></path>
  </svg>
)
